import { HttpHandler } from './HttpHandler';
import { environment } from '../enviroments';

function EmailSystemCore() {
  const sendSessionBooked = async (consultationID: string) => {
    const response = await HttpHandler({
      method: 'POST',
      url: `${environment.EMAIL_URL}/client/session/booked/${consultationID}`,
    });

    return response;
  };

  const sendSessionRescheduledOrCanceled =
    (type: 'reschedule' | 'cancel') => async (consultationID: string, reason: string) => {
      const url =
        type === 'reschedule'
          ? `${environment.EMAIL_URL}/session/rescheduled/${consultationID}`
          : `${environment.EMAIL_URL}/client/session/cancel/${consultationID}`;
      const response = await HttpHandler({
        method: 'POST',
        url,
        data: { reason },
      });

      return response;
    };

  const sendSubscription = async (
    typeOfEvent: 'created' | 'paused' | 'activated' | 'cancelled',
    subscriptionID: string
  ) => {
    const response = await HttpHandler({
      method: 'POST',
      url: `${environment.EMAIL_URL}/subscription/${typeOfEvent}/${subscriptionID}`,
    });

    return response;
  };

  return Object.freeze({
    sendSessionBooked,
    sendSessionRescheduledOrCanceled,
    sendSubscription,
  });
}

const EmailSystem = EmailSystemCore();

export default EmailSystem;
